export default {
  语言: 'language',
};
